import PubSub from "underpub-js";
import slick from "slick-carousel";
import CardBgImage from "../../../elements/Cards/CardBgImage/CardBgImage";

var ListingBgImageCardsSlider = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-ListingBgImageCardsSlider',
	};

	$.extend(true, this.options, options);

};

ListingBgImageCardsSlider.prototype.init = function() {

	var self = this;

	self.centerSlides = self.options.$el.attr("data-center-slides");
	self.$slides = self.options.$el.find(`.${self.options.baseClass}__cards`);
	self.$arrowPrev = self.options.$el.find(`.${self.options.baseClass}__arrow--prev`);
	self.$arrowNext = self.options.$el.find(`.${self.options.baseClass}__arrow--next`);

	self.initCarousel();

};

ListingBgImageCardsSlider.prototype.initCarousel = function() {

	var self = this;

	// initialize cloned slides after the cloning is complete
	self.$slides.on('init', function(slick) {
		self.initClonedSlides();
	});
	// init elements that slick may add after resize
	PubSub.subscribe("Sitewide:resized", function(){
		self.initClonedSlides();
	});

	self.$slides.slick({
		prevArrow: self.$arrowPrev,
		nextArrow: self.$arrowNext,
		dots: false,
		infinite: true,
		variableWidth: true,
		centerMode: self.centerSlides == "true",
		responsive: [
			{
				breakpoint: 420,
				settings: {
					slidesToShow: 1,
					variableWidth: false,
				}
			},
		]
	});

};

// This method is needed because Slick clones the slides when infinite is set to true.
// The cloned slides aren't present on page load, so they don't get initialized, so we
// initialize them here. Also, Slick copies the event listeners form the original slide,
// so we remove those here.
ListingBgImageCardsSlider.prototype.initClonedSlides = function() {

	const self = this;

	let $clonedSlides = self.options.$el.find(`.slick-cloned .el-CardBgImage`);

	$clonedSlides.each(function(){

		// remove previously attached event listeners
		$(this).off();

		// initialize the cloned CardBgImage
		var component = new CardBgImage({
			$el: $(this)
		});
		component.init();

	});

};

export default ListingBgImageCardsSlider;
